import config from './config';
import { IOpenMarketConfig } from './IOpenMarketConfig';

export type { IOpenMarketConfig };
export default config;
